import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { mount } from "svelte";
import App from "./App.svelte";
import { registerServiceWorker } from "./lib/install.svelte";

mount(App, { target: document.getElementById("app")! });
registerServiceWorker();
